export default function getFirstWord(label) {
  if (!label) {
    return '';
  }
  return label.split(' ')[0];
}
